
export const pdWebhooksToDeleteTasks = ({ pdWebhooks, currentAccountMapping, otherConnectedAccountsIds }) => {
  const { id: currentAccountMappingId } = currentAccountMapping;

  const result = {};
  const addResult = (key, { service, info = '', webhook }) => {
    while (result[key]) key = `dup_${key}`;
    if (key.startsWith('dup_')) info = `(Duplicate) ${info}`;
    result[key] = {
      key,
      deleteTask: {
        type: 'pd',
        action: 'delete',
        service,
        webhook,
        info,
      }
    };
  };

  // eslint-disable-next-line no-unused-vars
  for (const w of pdWebhooks) {
    const {
      name = '',
      webhook_object: {
        id: serviceId = '',
        summary: serviceSummary = '',
      } = {}
    } = w;

    const service = { id: serviceId, summary: serviceSummary };
    const webhook = { id: w.id };

    // filter out webhooks from other allowed accounts mappings
    if (otherConnectedAccountsIds.some(id => name.startsWith(`JIRA_integration_${id}`))) {
      continue;
    }

    if (!name.startsWith(`JIRA_integration_${currentAccountMappingId}_`)) {
      addResult(`invalid_name_${name}`, {
        info: 'There is no Jira account using this webhook',
        service,
        webhook,
      });
      continue;
    }

    if (name !== `JIRA_integration_${currentAccountMappingId}_${serviceId}`) {
      addResult(`invalid_name_${name}`, {
        info: 'webhook name is corrupted, we can not property track it',
        service,
        webhook,
      });
      continue;
    }

    addResult(name, { service, webhook });
  }

  return result;
};

